import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Container, Grid, makeStyles } from '@material-ui/core';
import { connect, useDispatch } from 'react-redux';
import { updateExpenseTypesPagination } from '../../../store/actions/expense_type/expense_type_action';
import { REACT_ROUTES } from '../../../constants/react_routes';
import SearchComponent from '../../ui_components/search';
import history from '../../../services/history';
import ExpenseTypesTable from './expense_types_table';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    centerAlign: {
        textAlign: 'center'
    }
}));

const ExpenseTypeList = ({ expenseTypes }) => {
    const { container, centerAlign } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = expenseTypes;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updateExpenseTypesPagination({...expenseTypes, page: 0, filters: { ...filters, search }}))
    }

    const handleAddExpenseClick = () => {
        history.push(REACT_ROUTES.EXPENSE_TYPE);
    }

    return (
        <Container className={container}>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={centerAlign}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddExpenseClick}
                    >
                        Kreirajte novi tip troška
                    </Button>
                </Grid>
            </Grid>
            <ExpenseTypesTable />
        </Container>
    )
}

ExpenseTypeList.propTypes = {
    expenseTypes: PropTypes.object
}

const mapStateToProps = (state) => ({
    expenseTypes: state.expenseTypes
});

export default connect(mapStateToProps)(ExpenseTypeList);
